
import { useAppDispatch } from '@/hooks/useAppDispatch';
import { expandDrawer } from '@/store/slices/copilot/copilotSlice';
import { cn } from '@/lib/utils';
import { Bot } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { motion } from 'framer-motion';
import { useAppSelector } from '@/hooks/useAppSelector';
import { selectSelectedProfile } from '@/store/slices/copilot-profiles/copilotProfilesSlice';

export const CopilotCollapseTab = () => {
  const dispatch = useAppDispatch();
  const activeProfile = useAppSelector(selectSelectedProfile);
  const profileName = activeProfile?.name || 'Pullse Copilot';

  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 10 }}
      transition={{
        type: 'spring',
        stiffness: 500,
        damping: 30,
      }}
      className="fixed right-0 top-1/2 -translate-y-1/2 z-40"
    >
      <Button
        onClick={() => dispatch(expandDrawer())}
        className={cn(
          "group relative px-1 py-5 h-auto w-6",
          "rounded-l-lg rounded-r-none",
          "bg-background/80 backdrop-blur-md border-y border-l border-primary/10",
          "shadow-md shadow-primary/5 hover:shadow-lg hover:shadow-primary/10",
          "transition-all duration-300 ease-out",
          "active:scale-95"
        )}
      >
        {/* Dynamic gradient background on hover */}
        <div 
          className="absolute inset-0 rounded-l-lg rounded-r-none opacity-0 group-hover:opacity-100 transition-all duration-500"
          style={{
            background: "linear-gradient(180deg, #8B5CF6 0%, #D946EF 100%)",
            filter: "blur(5px)",
          }}
        />
        
        {/* Content */}
        <div className="relative flex flex-col items-center gap-3">
          {/* Bot icon with pulsing animation */}
          <span className="relative flex h-4 w-4 shrink-0 overflow-hidden rounded-full group-hover:bg-white bg-gradient-to-br from-violet-500 to-fuchsia-500 transition-all duration-300">
            <span className="flex h-full w-full items-center justify-center animate-subtle-pulse">
              <Bot className="h-2.5 w-2.5 text-white group-hover:text-violet-500 transition-colors duration-300" />
            </span>
          </span>
          
          {/* Vertical text with gradient */}
          <span 
            className="font-medium tracking-wider [writing-mode:vertical-lr] rotate-180 text-[9px] text-primary/70 group-hover:text-white transition-colors duration-300"
            style={{
              textShadow: "0px 0px 10px rgba(255,255,255,0.2)"
            }}
          >
            {profileName.length > 12 ? `${profileName.substring(0, 12)}...` : profileName}
          </span>
        </div>
      </Button>
    </motion.div>
  );
};
